import { fbt } from 'fbtee'
import { HiddenRow } from '../../../components/HiddenRow'
import { SectionHeader } from '../../../components/SectionHeader'
import { UserAvatar } from '../../../components/UserAvatar'
import { useTimeFormat } from '../../../hooks/useTimeFormat'
import { useDayCutoff } from '../../../contexts/DayCutoffContext'
import { useScheduleMarkersContext } from './scheduleMarkersContext'
import { minutesToClockLabel, timeToMinutes } from './timeUtils'

/** Schedule settings: the shared lines and people the viewer hid, each with a way back. */
export function HiddenMarkersSection() {
  const { hiddenLines, hiddenAuthorIds, profiles, showLine, showAuthor } = useScheduleMarkersContext()
  const { hourCycle, locale } = useTimeFormat()
  const cutoff = useDayCutoff()
  if (hiddenLines.length === 0 && hiddenAuthorIds.length === 0) return null
  const showLabel = fbt('Show', 'Button in schedule settings that shows a hidden schedule line or person again').toString()

  return (
    <div className="space-y-2" data-testid="hidden-markers-section">
      <SectionHeader>
        <fbt desc="Section heading in schedule settings listing hidden custom lines and people">Hidden lines</fbt>
      </SectionHeader>
      {hiddenAuthorIds.map(uid => {
        const name = profiles[uid]?.displayName ?? ''
        return (
          <HiddenRow key={uid} avatar={<UserAvatar profile={profiles[uid]} fallbackName={name} size="xs" />} onShow={() => showAuthor(uid)} showLabel={showLabel}>
            {fbt('All lines from ' + fbt.param('name', name), 'Row in schedule settings for a person whose schedule lines are hidden')}
          </HiddenRow>
        )
      })}
      {hiddenLines.map(m => (
        <HiddenRow
          key={m.id}
          avatar={<UserAvatar profile={profiles[m.userId]} size="xs" />}
          onShow={() => showLine(m)}
          showLabel={showLabel}
        >
          <span className="tabular-nums">{minutesToClockLabel(timeToMinutes(m.time, cutoff), hourCycle, locale)}</span>
          {' · '}
          {m.label}
        </HiddenRow>
      ))}
    </div>
  )
}
